<script>
  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let data, onClick, query;
  let loading = true;
  let initialLoad = true;
  let table = null;
  let tableData = {
    columns: [
      {
        key: "name",
        label: M.NAME,
        class: "flex-1 mw-300 ws-normal",
        row: "created",
        rowLabel: M.CREATED_AT
      },
      { key: "subscribers", label: M.SUBSCRIBERS, type: "number", class: "mw-100" },
      { key: "open", label: M.OPEN_RATE, type: "percent", rowClass: "pay-status paid", class: "mw-100" },
      {
        key: "click",
        label: M.CLICK_RATE,
        type: "percent",
        rowClass: "order-status pending",
        class: "mw-100"
      },
      {
        type: "action",
        action: function (id, action, row) {
          if (action === "rename") {
            External.Tools.promptForInput(M.RENAME, M.INSERT_NEW_LIST_NAME, row.name, function (input) {
              row.name = input;
              row.created = null;
              External.Tools.makeWebsiteRequest({
                action: "setMarketingLists",
                data: {
                  isNew: false,
                  data: JSON.stringify(row)
                },
                onOk: function (response) {
                  load(0);
                }
              });
            });
          } else if (action === "delete") {
            External.Tools.prompt(M.DELETE, M.DELETE_LIST_TEXT, function () {
              External.Tools.makeWebsiteRequest({
                action: "deleteMarketingLists",
                data: {
                  id: id
                },
                onOk: function (response) {
                  load(0);
                }
              });
            });
          }
        },
        items: [
          { text: M.RENAME, icon: "fa-edit", tag: "rename" },
          { text: M.DELETE_TITLE, icon: "fa-trash", tag: "delete" }
        ],
        class: "mw-40"
      }
    ],
    rows: []
  };

  let load = (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;
    loading = true;
    
    if (page === 0) {
      tableData.rows = [];
    }

    let request = {
        page: page,
        withStats: true
      },
      filters = {};

    if (query !== "") {
      filters.name = query;
    }

    if (Object.keys(filters).length > 0) {
      request.filters = JSON.stringify(filters);
    }

    External.Tools.makeWebsiteRequest({
      action: "getMarketingLists",
      data: request,
      onOk: function (response) {
        if (response.data == null) {
          loading = false;
          return;
        }

        let items = response.data;
        data.count = items.length;

        items.forEach(function (item) {
          item.created = External.Tools.dateToShortStr(new Date(item.created));
        });

        if (table) table.addRows(items);
        loading = false;
      }
    });
  };

  function onClickRow(row) {
    onClick(row);
  }

  const nextPage = () => {};

  export function onReloadData() {
    load(0);
  }

  onMount(function () {
    // ignore, data is loaded from onReloadData
  });
</script>

<Table bind:this={table} data={tableData.rows} activeColumns={tableData.columns} loading={loading} onClick={onClickRow} nextPage={nextPage}>
  <div class="text-center" style="padding: 70px 0;">
    <h4>{M.NO_LISTS_AVAILABLE}</h4>
  </div>
</Table>
